
export function randInt(n){ return Math.floor(Math.random()*n) }

export function lighten(hex, amt){
  hex = hex.replace('#','')
  const num = parseInt(hex, 16)
  let r = (num>>16) + amt; r = Math.max(0, Math.min(255, r))
  let g = ((num>>8)&0x00FF) + amt; g = Math.max(0, Math.min(255, g))
  let b = (num&0x0000FF) + amt; b = Math.max(0, Math.min(255, b))
  return '#' + ((1<<24) + (r<<16) + (g<<8) + b).toString(16).slice(1)
}

export function getRandomRgbTuple() {
  const red = Math.floor(Math.random() * 256);
  const green = Math.floor(Math.random() * 256);
  const blue = Math.floor(Math.random() * 256);
  return `(${red},${green},${blue})`;
}

export function generateColorDictionary() {
  const dictionary = {};

  for (let i = 97; i <= 122; i++) {
    const letter = String.fromCharCode(i);
    dictionary[letter] = getRandomRgbTuple();
  }

  for (let i = 65; i <= 90; i++) {
    const letter = String.fromCharCode(i);
    dictionary[letter] = getRandomRgbTuple();
  }

  for (let i = 0; i <= 9; i++) {
    dictionary[String(i)] = getRandomRgbTuple();
  }

  return dictionary;
}
